import {
  AIModelChoices,
  type AluminiumComposition,
  type Annotation,
  type EvaluatedSpecification,
  type HDPEComposition,
  type PETComposition,
  type SimpleEvaluatedSpecification,
  type SimpleMaterialQualityCategory,
} from 'api';
import { Box } from 'ui';

import { AiFilters } from '../../../annotations';
import { QualityResults } from '../../../breakdowns';
import { AiFeedbackSwitch } from '../AiFeedbackSwitch/AiFeedbackSwitch';

type EvaluatedSpecificationLike = EvaluatedSpecification | SimpleEvaluatedSpecification;
type MaterialCategoryContext = Pick<SimpleMaterialQualityCategory, 'id' | 'name'> | null;

type Props = {
  selectedAnnotation: Annotation[];
  hiddenCategories: readonly string[];
  handleHideCategory: (label: string) => void;
  handleToggleLegend: (checked: boolean) => void;
  showLegend: boolean;
  model: AIModelChoices;
  showAerosols?: boolean;
  showFeedback?: boolean;
  aluminiumComposition?: AluminiumComposition;
  hdpeComposition?: HDPEComposition;
  petComposition?: PETComposition;
  evidenceId: number;
  hasValidModelResults?: boolean;
  evaluatedSpecs?: readonly EvaluatedSpecificationLike[];
  latestRunAIVersion?: string;
  materialCategory?: MaterialCategoryContext;
};

export const AiFiltersAndBreakdownSidebar = ({
  selectedAnnotation,
  hiddenCategories,
  handleHideCategory,
  handleToggleLegend,
  showLegend,
  model,
  aluminiumComposition,
  hdpeComposition,
  showAerosols,
  petComposition,
  showFeedback,
  evidenceId,
  hasValidModelResults,
  evaluatedSpecs,
  latestRunAIVersion,
  materialCategory,
}: Props) => {
  return (
    <Box
      sx={{
        paddingX: 2,
        marginBottom: 10,
      }}
    >
      <AiFilters
        selectedAnnotation={selectedAnnotation}
        hiddenCategories={hiddenCategories}
        handleHideCategory={handleHideCategory}
        handleToggleLegend={handleToggleLegend}
        showLegend={showLegend}
        shouldShowSidebarLegend={!model.startsWith(AIModelChoices.other)}
        model={model}
        showAerosols={showAerosols}
        hasValidModelResults={hasValidModelResults}
      />
      {showFeedback ? (
        <Box
          sx={{
            my: 2,
          }}
        >
          <AiFeedbackSwitch evidenceId={evidenceId} />
        </Box>
      ) : null}
      <QualityResults
        model={model}
        aluComposition={aluminiumComposition}
        hdpeComposition={hdpeComposition}
        petComposition={petComposition}
        evaluatedSpecs={evaluatedSpecs ? [...evaluatedSpecs] : undefined}
        isLoading={false}
        showAlerts={false}
        latestRunAIVersion={latestRunAIVersion}
        materialCategory={materialCategory}
      />
    </Box>
  );
};
